import { render, staticRenderFns } from "./PatientViewOrder.vue?vue&type=template&id=469c9c6c"
import script from "./PatientViewOrder.vue?vue&type=script&lang=js"
export * from "./PatientViewOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports